import { createAsyncThunk } from "@reduxjs/toolkit";
import { COREURL } from "../../constants/api_constants";
import { ApiServices } from "../../services/api_services";

const getUserDetails = createAsyncThunk("users/getUserById", async (id: any) => {
  return ApiServices.get(COREURL, `/get_user_details_list/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

const getWebChatwidgetDetails = createAsyncThunk("/webChat/get_widget", async () => {
  return ApiServices.get(COREURL, `/get_webchat_widget_list`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export { getUserDetails, getWebChatwidgetDetails };
